import { IComment } from '@sdk/contracts';
import { Avatar } from 'antd';
import { DefaultTheme, useTheme } from 'styled-components';

import { LikesWrapper, UserInfoWrapper, ThreadWrapper } from './UserInfo.styles';

import { Icon } from '@/components/Icon';
import { useMutateEvents, useProfile } from '@/store';

type Props = {
  comment: IComment;
};

const AVATAR_SIZE = 32;
const FAV_ICON_SIZE = 24;

export const UserInfo: React.FC<Props> = ({ comment }) => {
  const { colors } = useTheme();
  const { profile } = useProfile();
  const { changeUsefulCommentVote } = useMutateEvents();
  const { sender } = comment;

  const isLiked = comment.usefulComment?.some(_id => _id === profile?._id);

  const handleChangeUsefulCommentVote = () => {
    if (!profile?._id) return;
    changeUsefulCommentVote({ commentId: comment._id, userId: profile._id });
  };

  return (
    <UserInfoWrapper $hasMoreAnswers={(comment?.messages?.length ?? 0) > 0 ? true : false}>
      <Avatar src={sender.avatar?.url} size={AVATAR_SIZE} style={{ flex: 'none' }}>
        {!sender.avatar?.url && `${sender.name[0]}${sender.lastName[0]}`}
      </Avatar>
      <LikesWrapper>
        <Icon
          i={isLiked ? 'FavoriteFilled' : 'Favorite'}
          size={FAV_ICON_SIZE}
          onClick={handleChangeUsefulCommentVote}
          color={colors.green6 as keyof DefaultTheme['colors']}
        />
        <div>{comment.usefulComment?.length}</div>
      </LikesWrapper>
      <ThreadWrapper />
    </UserInfoWrapper>
  );
};
